const initUploadList = (list, rem) => {
  const type = {
    1: '单位介绍信',
    2: '经办人身份证或工作证等有效身份证件',
    3: '经办人身份证',
    4: '居民委员会介绍信',
    5: '业主委员会介绍信（未成立业主委员会的提供社区或街道介绍信）',
    6: '物业公司介绍信和物业管理合同原件',
    7: '房屋所有权证明：不动产证；或购房合同；或拍卖合同；或付款证明；或（土地出让合同；土地使用证；公证书；法院判决或其他能说明产权关系的证明材料）',
    8: '租赁合同原件',
    9: '租赁合同',
    10: '权属人委托书（含产权人身份证复印件）',
    11: '律师事务所介绍信或者授权委托书；（注明与该案件有关的情况说明）',
    12: '律师执业证书',
    13: '外国组织和个人利用已开放的城建档案，应该按照国家档案局《外国组织和个人利用我国档案试行办法》办理。',
    14: '合法权属证明',
    15: '个人身份证件（委托他人查档的，还须出具委托人的委托书及被委托人身份证件）',
    16: '单位介绍信或其他合法证明材料'
  }

  const remType = {
    1: '有效身份证件：居民身份证、居民临时身份证、工作证、军官证等',
    2: '若无合同原件，物业公司可在合同复印件上加盖单位签章，并注明复印与原件相符。',
    3: '若无合同原件，租赁单位可在合同复印件上加盖单位签章，并注明复印与原件相符。'
  }

  return list.map(val => ({
    type: val,
    title: type[val],
    remarks: remType[rem],
    files: []
  }))
}

export const checkerTypeList = [
  {
    value: 'jiade',
    text: 'jiade',
    uploadList: initUploadList([16, 3])
  }, 
  {
    value: 'UNIT_TYPE_A',
    text: '国家机关、武装部队、政党',
    uploadList: initUploadList([1, 2], 1)
  }, {
    value: 'UNIT_TYPE_B',
    text: '建设单位',
    remarks: '有效身份证件：居民身份证、居民临时身份证、工作证、军官证等',
    uploadList: initUploadList([1, 3])
  }, {
    value: 'UNIT_TYPE_C',
    text: '施工、监理、设计、勘察单位',
    uploadList: initUploadList([1, 3])
  }, {
    text: '居民委员会',
    value: 'UNIT_TYPE_D',
    uploadList: initUploadList([1, 3])
  }, {
    value: 'UNIT_TYPE_E',
    text: '业主委员会',
    uploadList: initUploadList([1, 3])
  },
  {
    value: 'SupervisionUnit',
    text: '监理单位',
    uploadList: initUploadList([1, 3])
  },
  {
    value: 'UNIT_TYPE_F',
    text: '物业公司',
    uploadList: initUploadList([6, 3], 2)
  }, {
    value: 'UNIT_TYPE_G',
    text: '产权单位',
    uploadList: initUploadList([1, 7, 3])
  }, {
    value: 'UNIT_TYPE_H',
    text: '租赁单位',
    uploadList: initUploadList([8, 3], 3)
  }, {
    value: 'UNIT_TYPE_I',
    text: '产权人',
    uploadList: initUploadList([14, 15])
  }, {
    value: 'UNIT_TYPE_J',
    text: '租赁人',
    uploadList: initUploadList([1, 3])
  }, {
    value: 'UNIT_TYPE_K',
    text: '律师',
    uploadList: initUploadList([11, 12])
  }, {
    value: 'UNIT_TYPE_L',
    text: '境外组织和个人',
    uploadList: initUploadList([13])
  }
]

export const escapeToHtml = (str) => {
  const arrEntities = {
    'lt': '<',
    'gt': '>',
    'nbsp': ' ',
    'amp': '&',
    'quot': '"'
  }
  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, (all, t) => {
    return arrEntities[t]
  })
}

export const formatDate = (time, format = 'yyyy-MM-dd') => {
  if (!time) return ''
  const date = new Date(time)
  const o = {
    "M+" : date.getMonth()+1, //month
    "d+" : date.getDate(),    //day
    "h+" : date.getHours(),   //hour
    "m+" : date.getMinutes(), //minute
    "s+" : date.getSeconds(), //second
    "q+" : Math.floor((date.getMonth() + 3) /3),  //quarter
    "S" : date.getMilliseconds() //millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp("("+ k +")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length))
    }
  }
  return format
}

export const initEngField = (data = {}) => {
  return [
    {
      key: '工程编号',
      val: data.ENG_NO
    }, {
      key: '工程档号',
      val: data.ENG_ID
    }, {
      key: '工程名称',
      val: data.ENG_NAME
    }, {
      key: '工程地址',
      val: data.ENG_LOCATION
    }, {
      key: '原编档号',
      val: data.OLD_ENG_ID
    }, {
      key: '档案分类',
      val: data.ARCH_CATEGORY_CODE
    }, {
      key: '建设工程分类',
      val: data.ENG_CATEGORY_CODE
    }, {
      key: '缩微(光盘)号',
      val: data.MICRO_NO
    }, {
      key: '用地面积',
      val: data.LAND_USE_AREA
    }, {
      key: '建筑面积',
      val: data.CONSTRUCTION_AREA
    }, {
      key: '开工时间',
      val: data.START_DATE
    }, {
      key: '竣工时间',
      val: data.END_DATE
    }, {
      key: '建设单位',
      val: data.DEVELOPMENTS_ORG_NAME
    }, {
      key: '施工单位',
      val: data.CONSTRUCT_ORG_NAME
    }, {
      key: '监理单位',
      val: data.SUPERVISION_ORG_NAME
    }, {
      key: '勘察单位',
      val: data.RECONNAISSANCE_ORG_NAME
    }, {
      key: '设计单位',
      val: data.DESIGN_ORG_NAME
    }, {
      key: '用地规划许可证号',
      val: data.LAND_USE_PLANNING_NO
    }, {
      key: '施工许可证号',
      val: data.CONSTRUCT_NO
    }
  ]
}

export const initArchField = (data = {}) => {
  return [
    {
      key: '案卷序号',
      val: data.ENG_ARCH_NO
    }, {
      key: '总登记号',
      val: data.REG_NO
    }, {
      key: '原档号',
      val: data.OLD_ARCH_ID
    }, {
      key: '案卷题名',
      val: data.ARCH_TITLE,
      // span: 24
    }, {
      key: '编制单位',
      val: data.MAKE_ORG_NAME
    }, {
      key: '案卷厚度',
      val: data.ARCH_WIDTH
    }, {
      key: '案卷类型',
      val: data.ARCH_TYPE_CODE
    }, {
      key: '录入人',
      val: data.CREATED_BY
    }, {
      key: '录入日期',
      val: data.CREATED_DT
    }, {
      key: '审核人',
      val: data.CHECKED_BY
    }, {
      key: '审核日期',
      val: data.CHECKED_DT
    }, {
      key: '整理人',
      val: data.ARRANGED_BY
    }, {
      key: '整理时间',
      val: data.ARRANGED_DT
    }, {
      key: '文字页数',
      val: data.TEXT_NUMS
    }, {
      key: '图纸页数',
      val: data.DRAW_NUMS
    }, {
      key: '照片页数',
      val: data.PHOTO_NUMS
    }
  ]
}

export const initFileField = (data = {}) => {
  return [
    {
      key: '文件序号',
      val: data.FILE_NO
    }, {
      key: '文件题名',
      val: data.FILE_TITLE
    }, {
      key: '文件档号',
      val: data.FILE_ID
    }, {
      key: '文(图)号',
      val: data.FILE_IMAGE_NO
    }, {
      key: '责任者',
      val: data.RESPONSIBILITY
    }, {
      key: '稿本',
      val: data.MANUSCRIPT_CODE
    }, {
      key: '保管期限',
      val: data.STORAGE_TYPE_CODE
    }, {
      key: '密级',
      val: data.SECURITY_LEVEL_CODE
    }, {
      key: '保密期限',
      val: data.STORAGE_PERIOD_CODE
    }, {
      key: '载体类型',
      val: data.MEDIA_TYPE_CODE
    }, {
      key: '规格',
      val: data.SPEC_CODE
    }, {
      key: '页次',
      val: data.PAGE_NO
    }, {
      key: '文字(页数)',
      val: data.TEXT_NUMS
    }, {
      key: '图纸(张数)',
      val: data.DRAWING_NUMS
    }, {
      key: '底图(张数)',
      val: data.BASE_MAP_NUMS
    }, {
      key: '照片(张数)',
      val: data.PHONE_NUMS
    }, {
      key: '底片(张数)',
      val: data.NEGATIVE_NUMS
    }, {
      key: '开始日期',
      val: data.CREATED_START
    }, {
      key: '结束日期',
      val: data.CREATED_END
    }, {
      key: '附注',
      val: data.NOTE
    }, {
      key: '提要',
      val: data.FILE_SUMMARY
    }
  ]
}

export const localStoragePackage = (type, key, val) => {
  if (type === 'set') {
    localStorage.setItem(key, JSON.stringify(val))
  } else if (type === 'get') {
    return JSON.parse(localStorage.getItem(key))
  } else if (type === 'del') {
    localStorage.removeItem(key)
  }
}

export const purposeOfArchiving = [
  {
    key: '1',
    val: '房屋产权'
  }, {
    key: '2',
    val: '改建扩建'
  }, {
    key: '3',
    val: '土地权属'
  }, {
    key: '4',
    val: '资质评定'
  }, {
    key: '5',
    val: '工作考查'
  }, {
    key: '6',
    val: '编史修志'
  }, {
    key: '7',
    val: '经济建设'
  }, {
    key: '8',
    val: '宣传教育'
  }, {
    key: '9',
    val: '学术研究'
  }, {
    key: '10',
    val: '经济纠纷'
  }, {
    key: '11',
    val: '业主维权'
  }
]

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)
}

export const calcBeforeDay = (day = 0) => {
  return new Date(Number(new Date()) - (day * 24 * 60 * 60 * 1000))
}

export const calcBeforeMonth = (month = 0) => {
  return new Date(Number(new Date().setMonth((new Date().getMonth() - month))))
}

export const sleep = function (method) {
  return new Promise((resolve) => {
    (function sleep () {
      setTimeout(() => {
        if (method()) {
          sleep()
        } else {
          resolve()
        }
      }, 10)
    })()
  })
}


export const getQueryString = function(name) {
  let qsStr = location.hash
  if (qsStr.indexOf(name) === -1) {
    qsStr = location.search
  }
 const reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)")
 const r = qsStr.substr(1).match(reg)
 if (r != null)
 return  unescape(r[2])
 return null
}